import APIHelper from './APIHelper';

export const globalLoginAPI = new APIHelper('/global-login');
export const globalForgotPasswordAPI = new APIHelper('/global-forgot-password');
